import { Suspense } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import ReactGA from "react-ga4";
import App from "./app";

// ----------------------------------------------------------------------

const root = ReactDOM.createRoot(document.getElementById("root")!);
if (import.meta.env.NODE_ENV === "production") {
	ReactGA.initialize(import.meta.env.VITE_GA_ID as string);
}
root.render(
	<>
		<BrowserRouter>
			<Suspense>
				<App />
			</Suspense>
		</BrowserRouter>
		<ToastContainer />
	</>,
);
